module.exports = __webpack_public_path__ + "img/ndmeme.1e91ed3a.svg";